import { createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-body" }
const _hoisted_2 = ["textContent"]
const _hoisted_3 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_modal_base = _resolveComponent("modal-base")!

  return (_openBlock(), _createBlock(_component_modal_base, { onDismiss: _ctx.dismiss }, {
    title: _withCtx(() => [
      _createTextVNode(" 確認 ")
    ]),
    "modal-content": _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("p", null, [
          _createTextVNode("納品書の下書きを削除してもよろしいですか？（日付："),
          _createElementVNode("span", {
            textContent: _toDisplayString(_ctx.deliveryDate)
          }, null, 8, _hoisted_2),
          _createTextVNode("）")
        ])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-secondary",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.dismiss && _ctx.dismiss(...args)))
        }, "キャンセル"),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-danger",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.deleteSlip && _ctx.deleteSlip(...args)))
        }, "削除")
      ])
    ]),
    _: 1
  }, 8, ["onDismiss"]))
}